
/*
 * VNCmail : A whole new experience in enterprise email communication.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AppService } from "src/app/services/app.service";

@Component({
    selector: "vp-modify-recuring-appointment-dialog",
    templateUrl: "./modify-recur-appointment-dialog.component.html"
})
export class ModifyRecurAppointmentDialogComponent implements OnInit, OnDestroy {
    selectedOption: string = "instance";
    eventName: string = "";
    openEvent: boolean =  false;
    currentTheme = localStorage.getItem("theme");
    isFluid: boolean = false;
    constructor(
        private dialogRef: MatDialogRef<ModifyRecurAppointmentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private appService: AppService,
    ) {
        this.isFluid = this.appService.isInsideIframe();
        if (this.data.eventName) {
            this.eventName = this.data.eventName;
        }
        if (this.data.openEvent) {
            this.openEvent = true;
        }
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    cancel(): void {
        this.close();
    }

    close(value?: string): void {
        this.dialogRef.close({ value: value });
    }

    submit(): void {
        this.close(this.selectedOption);
    }
}
